import { Link } from 'react-router-dom';
import { Collection } from '../../types/api';
import ProductCard from '../ProductCard/ProductCard';
import './Collections.css';
import Carousel from '../Carousel/Carousel';
import { Campaign } from '../../types/commerce';
export default function CollectionSection({
  collection,
  slides = [],
}: {
  collection: Collection;
  slides?: Campaign[];
}) {
  return (
    <section className="collection-section" aria-labelledby={`collection-${collection.slug}`}>
      <div className="collection-section__header">
        <h2 id={`collection-${collection.slug}`}>{collection.title}</h2>
        <Link
          className="collection-section__more"
          to={`/collections/${collection.slug}`}
          aria-label={`Explore more ${collection.title} products`}
        >
          Explore more <span aria-hidden="true">→</span>
        </Link>
      </div>
      <Carousel label={collection.title} slides={slides} compact />
      {collection.items.length ? (
        <ul className="collection-section__grid">
          {collection.items.map((p) => (
            <ProductCard key={p.item_id} result={p} />
          ))}
        </ul>
      ) : (
        <p>No products available yet.</p>
      )}
    </section>
  );
}
